// Generated by purs version 0.14.4
import * as Affjax_RequestHeader from "../Affjax.RequestHeader/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic_Geocoding_RPC_Sites_Types from "../Restaumatic.Geocoding.RPC.Sites.Types/index.js";
import * as Restaumatic_I18nWrapper from "../Restaumatic.I18nWrapper/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Utils_DataLoading from "../Utils.DataLoading/index.js";
var sitesRPC = function (dictEncode) {
    return function (dictDecode) {
        return function (dictRPCMethodName) {
            return function (req) {
                return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Restaumatic_I18nWrapper.getGlobalLocale))(function (locale) {
                    return Network_JsonRPC.rpc(dictRPCMethodName)(Effect_Aff.monadAff)(Network_JsonRPC.runAffjax(dictEncode)(dictDecode)("/api/v1/sites/rpc")([ new Affjax_RequestHeader.RequestHeader("x-app-locale", Data_Show.show(Restaumatic_Locales.showLocale)(locale)) ]))(req);
                });
            };
        };
    };
};
var hoistErrors = function (v) {
    if (v instanceof Data_Either.Left) {
        return new Data_Either.Left(Utils_DataLoading.NetworkError.value);
    };
    if (v instanceof Data_Either.Right) {
        return new Data_Either.Right(v.value0);
    };
    throw new Error("Failed pattern match at Restaumatic.Services.Geocoding.Higgs (line 29, column 1 - line 29, column 60): " + [ v.constructor.name ]);
};
var geocode = function (accountId) {
    return function (restaurantId) {
        return function (fromPS) {
            return function (country) {
                return function (streetAddress) {
                    return sitesRPC(Restaumatic_Geocoding_RPC_Sites_Types.encodeGeocodeRequest)(Restaumatic_Geocoding_RPC_Sites_Types.decodeGeocodeResponse)(Restaumatic_Geocoding_RPC_Sites_Types.rpcMethodNameGeocodeRequest)({
                        country: country,
                        streetAddress: streetAddress,
                        fromPS: new Data_Maybe.Just(fromPS),
                        restaurantId: restaurantId,
                        accountId: accountId
                    });
                };
            };
        };
    };
};
var convertCoords = function (v) {
    return {
        latitude: v.lat,
        longitude: v.lon
    };
};
var geocodeAddress = function (accountId) {
    return function (restaurantId) {
        return function (fromPS) {
            return function (country) {
                return function (address) {
                    return Data_Functor.map(Effect_Aff.functorAff)((function () {
                        var $12 = Data_Functor.map(Data_Either.functorEither)((function () {
                            var $14 = Data_Newtype.unwrap();
                            return function ($15) {
                                return (function (c) {
                                    return {
                                        location: Data_Functor.map(Data_Maybe.functorMaybe)(convertCoords)(c)
                                    };
                                })((function (v) {
                                    return Data_Record.getField(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "coordinates";
                                        }
                                    })())(Data_Symbol.SProxy.value)(v);
                                })($14($15)));
                            };
                        })());
                        return function ($13) {
                            return $12(hoistErrors($13));
                        };
                    })())(geocode(accountId)(restaurantId)(fromPS)(country)(address));
                };
            };
        };
    };
};
var higgsGeocoding = function (accountId) {
    return function (restaurantId) {
        return function (fromPS) {
            return {
                geocodeAddress: geocodeAddress(accountId)(restaurantId)(fromPS)
            };
        };
    };
};
export {
    higgsGeocoding
};
//# sourceMappingURL=index.js.map
